const { getElement } = window.BAO.Utils

const selectors = {
  carousel: '.car-MobileCarousel_Slides',
}

class MobileNavigation extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.drawer = this.externalEls.drawer?.element
    this.buttons = this.els.button.elements
    this.panels = this.els.panel.elements
    this.backButtons = this.els.back.elements
    this.closeButtons = this.els.close.elements

    if (!this.querySelector('*')) {
      return
    }

    // --- V1: postMessage listener (harmless in V2, the iframe never loads) ---
    window.addEventListener(
      'message',
      event => {
        if (event.origin !== 'https://wisepops.net') {
          return
        }

        const { action, type } = event.data

        if (type === 'external') {
          if (action === 'close') {
            this.closeAll()
          }

          if (action === 'back') {
            const panel = this.querySelector(
              '.mob-NavigationPanel[data-panel="notifications"]',
            )
            this.closePanel(panel)
          }
        }
      },
      false,
    )

    // --- V2: observe aria-expanded on the bell to detect feed close ---
    this._setupV2FeedCloseObserver()

    this.closeButtons.forEach(btn => {
      this.listeners.add(btn, 'click', () => {
        this.closeAll()
      })
    })

    this.backButtons.forEach(btn => {
      this.listeners.add(btn, 'click', () => {
        const panel = btn.closest('[data-mobile-navigation-el="panel"]')
        if (panel) {
          this.closePanel(panel)
        }
      })
    })

    this.buttons.forEach(btn => {
      this.listeners.add(btn, 'click', () => {
        const target = btn.dataset.target
        if (target) {
          const panel = this.panels.find(
            element => element.dataset.panel === target,
          )
          if (panel) {
            this.openPanel(panel)
          }
        }
      })
    })
  }

  // Watches for V2 feed close (aria-expanded going from "true" to "false")
  _setupV2FeedCloseObserver () {
    const bell = document.querySelector('.wisp_ready')

    if (!bell) {
      // Bell not ready yet — retry when it appears
      const bodyObserver = new MutationObserver(() => {
        const readyBell = document.querySelector('.wisp_ready')
        if (readyBell) {
          bodyObserver.disconnect()
          this._observeBellAriaExpanded(readyBell)
        }
      })
      bodyObserver.observe(document.body, {
        subtree: true,
        childList: true,
        attributes: true,
      })
    } else {
      this._observeBellAriaExpanded(bell)
    }
  }

  _observeBellAriaExpanded (bell) {
    // Only needed in V2 (no #wisp_container)
    if (document.querySelector('#wisp_container')) return

    let wasOpen = bell.getAttribute('aria-expanded') === 'true'

    const observer = new MutationObserver(() => {
      const isOpen = bell.getAttribute('aria-expanded') === 'true'

      if (wasOpen && !isOpen) {
        // Feed was just closed — close the mobile nav panel too
        const panel = this.querySelector(
          '.mob-NavigationPanel[data-panel="notifications"]',
        )
        if (panel && panel.getAttribute('aria-expanded') === 'true') {
          this.closePanel(panel)
        }
      }

      wasOpen = isOpen
    })

    observer.observe(bell, {
      attributes: true,
      attributeFilter: ['aria-expanded'],
    })
  }

  closePanel (panel) {
    panel.setAttribute('aria-expanded', 'false')

    const carousel = getElement(selectors.carousel, { context: panel })
    this.resetCarouselScroll(carousel)

    const panelClosed = new CustomEvent('panelClosed', {
      detail: {
        key: panel.dataset.panel,
      },
    })

    document.dispatchEvent(panelClosed)
  }

  openPanel (panel) {
    this.drawer.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })

    panel.setAttribute('aria-expanded', 'true')

    const panelOpened = new CustomEvent('panelOpened', {
      detail: {
        key: panel.dataset.panel,
      },
    })

    document.dispatchEvent(panelOpened)
  }

  resetCarouselScroll (carousel) {
    if (!carousel) return

    carousel.scrollLeft = 0
  }

  closeAll () {
    this.panels.forEach(panel => {
      this.closePanel(panel)
    })
  }
}

if (!customElements.get('mobile-navigation')) {
  customElements.define('mobile-navigation', MobileNavigation)
}
